import { render } from "./Info.vue?vue&type=template&id=fa1a238c&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=fa1a238c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fa1a238c"

export default script